var _path, _path2, _path3, _path4, _path5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtmlIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 157,
    viewBox: "0 0 127 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H96L126 30V151C126 154.314 123.314 157 120 157H16C12.686 157 10 154.314 10 151V6C10 2.686 12.686 0 16 0Z",
    fill: "#E1E6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 0V30H126",
    fill: "#BCC8CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 43L29 56L44 69M88 43L103 56L88 69M73 39L59 73",
    stroke: "#E76F28",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 88H126V131H0V88Z",
    fill: "#E76F28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 131H10V139L0 131Z",
    fill: "#B94F16"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 63,
    y: 117,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "HTML")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/HTML-icon.a2e8752495f98706609f8aa7786fadb6.svg";
export { ForwardRef as ReactComponent };